module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/701d84c3cce8880d0802ddcccb03ecf3.png";